import {
  EventFormAnswerFilters,
  EventFormAnswersExportResponse,
} from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { handleApiCall } from "../api-error-handler";
import { privateAxios } from "../axiosInstances";
import { eventFormAnswersQueryKeys } from "../query-keys";

const getUserEventFormAnswersQuery = (eventId: string, params?: EventFormAnswerFilters) =>
  handleApiCall(() =>
    privateAxios.get<EventFormAnswersExportResponse>(`/event-form-answers/${eventId}`, { params }),
  );

export const useGetUserEventFormAnswersQuery = (
  eventId: string,
  params?: EventFormAnswerFilters,
) => {
  return useQuery({
    queryKey: eventFormAnswersQueryKeys.userAnswers(eventId, params),
    queryFn: () => getUserEventFormAnswersQuery(eventId, params),
    enabled: !!eventId,
  });
};

export const getEventFormAnswersForExportQuery = (eventId: string) =>
  handleApiCall(() => privateAxios.get<string>(`/event-form-answers/${eventId}/export`));
